import * as Sentry from '@sentry/react'
import { configureStore } from '@reduxjs/toolkit'

import bundleReducer from './bundle/bundleSlice'
import configResultReducer from './configResult/configResultSlice'
import customerReducer from './customer/customerSlice'
import initReducer from './init/initSlice'
import internalSaveEventReducer from './internalSaveEvent/internalSaveEventSlice'
import itemsReducer from './items/itemsSlice'
import lfcReducer from './lfc/lfcSlice'
import modelReducer from './model/modelSlice'
import requestsReducer from './requests/requestsSlice'
import selectedItemReducer from './selectedItem/selectedItemSlice'
import uiReducer from './ui/uiSlice'
import yassReducer from './yass/yassSlice'

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    if (action.type === 'customer/handleCustomer') {
      // Return null to not log the action to Sentry
      return null
    }
    if (action.type === 'thunks/loadConfig/fulfilled') {
      // Return a transformed action payload to remove sensitive information
      return {
        ...action,
        payload: {
          ...action.payload,
          yassConfigHashKey: null,
        },
      }
    }
    if (
      action.type === 'thunks/addToCart_aggregated/fulfilled' ||
      action.type === 'thunks/submitForm_aggregated/fulfilled'
    ) {
      // Return a transformed action payload to remove sensitive information
      return {
        ...action,
        payload: {
          ...action.payload,
          _configHashKey: null,
        },
      }
    }

    return action
  },
  stateTransformer: (state) => {
    // Transform the state to remove sensitive information
    const transformedState = {
      ...state,
      customer: null,
      yass: {
        ...state.yass,
        configHashKey: null,
      },
    }

    return transformedState
  },
})

const store = configureStore({
  reducer: {
    bundle: bundleReducer,
    configResult: configResultReducer,
    customer: customerReducer,
    init: initReducer,
    internalSaveEvent: internalSaveEventReducer,
    items: itemsReducer,
    lfc: lfcReducer,
    model: modelReducer,
    requests: requestsReducer,
    selectedItem: selectedItemReducer,
    ui: uiReducer,
    yass: yassReducer,
  },
  enhancers: [sentryReduxEnhancer],
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export default store
